export default "__VITE_ASSET__BX9OiuUQ__"